import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

import { getFromBreakpoint } from '../../styles/breakpoints';

const useStyles = makeStyles()((theme) => ({
	itemsBlock: {
		marginTop: theme.spacing.large,
	},
	itemContentBlock: {
		marginTop: theme.spacing.medium,
	},
	upcomingBookingsGrid: {
		display: 'grid',
		gridGap: theme.spacing.small,
		gridTemplateColumns: `repeat(1, minmax(100px, 1fr))`,

		[getFromBreakpoint('md')]: {
			gridTemplateColumns: `repeat(2, minmax(100px, 1fr))`,
		},
	},
	pastCancelledBookingsGrid: {
		display: 'grid',
		gridGap: theme.spacing.small,
		gridTemplateColumns: `repeat(1, minmax(100px, 1fr))`,

		[getFromBreakpoint('md')]: {
			gridTemplateColumns: `repeat(2, minmax(100px, 1fr))`,
		},

		[getFromBreakpoint('lg')]: {
			gridTemplateColumns: `repeat(3, minmax(100px, 1fr))`,
		},
	},
}));

export default useStyles;
